var render = function (_h,_vm) {var _c=_vm._c;return _c('row',_vm._g(_vm._b({attrs:{"appearance":"spaced","space":"xl"}},'row',_vm.data.attrs,false),_vm.data.on),[_c('cell',{attrs:{"cols":"12"}},[_vm._t("default")],2),(_vm.scopedSlots.submits)?_c('cell',{attrs:{"cols":"12"}},[_vm._t("submits")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }